import {makeStyles} from "@mui/styles";


export default makeStyles(() => ({
    leafletContainer: {
        width: '100%',
        height: '75vh',
        zIndex: '0'
    }
}))